@if (itemsLength()) {
  <div class="palantir-bulk-actions" [@scaleInOut]>
    <div class="palantir-bulk-actions__selected">
      <palantir-text type="description" size="xs" class="palantir-bulk-actions__selected__text">
        {{ itemsLength() }} {{ selectedLabel() }}
      </palantir-text>
    </div>

    <div class="palantir-bulk-actions__items">
      <ng-content select="[palantir-bulk-actions-item], palantir-bulk-actions-item" />
    </div>

    @if (!hideMenuButton()) {
      <palantir-button
        class="palantir-bulk-actions__more"
        [cdkMenuTriggerFor]="menu"
        theme="transparent"
        size="xs"
        layout="icon"
        icon="more-horizontal-outline"
      />
    }

    <ng-template #menu>
      <palantir-content class="palantir-menu palantir-bulk-actions__menu" cdkMenu>
        <ng-content select="[palantir-bulk-actions-item-menu], palantir-bulk-actions-item-menu" />
      </palantir-content>
    </ng-template>
  </div>
}
